import { acquiredSdk, confirmParams, components } from '../acquired'

const SDK_UNAVAILABLE = 'The Acquired SDK is not initialised, so there is no payment to confirm.'

export const confirmPayment = async () => {
    // Without a payment session the SDK is null. The external rule already handled the resulting
    // TypeError; rejecting deliberately only puts a readable reason in its DEBUG log instead.
    if (!acquiredSdk) {
        return Promise.reject(new Error(SDK_UNAVAILABLE))
    }

    return await acquiredSdk.confirmPayment({
        components,
        confirmParams: confirmParams,
    })
}
